import script from "./UserExaminationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserExaminationModal.vue?vue&type=script&setup=true&lang=ts"

export default script